import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { scrollToSection } from "@/App";

const LINKS = [
  { id: "home", label: "Home" },
  { id: "tools", label: "Our Tools" },
  { id: "about", label: "About Proxima" },
  { id: "contact", label: "Contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToSection(id), open ? 250 : 0);
  };

  return (
    <>
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            className="fixed inset-0 z-[100] flex flex-col bg-coal/95 backdrop-blur-2xl"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="flex items-center justify-between px-6 py-4">
              <img src="/logo.png" alt="Proxima Centauri Tools logo" className="h-11 w-11 object-cover" />
              <button
                data-testid="mobile-menu-close-button"
                onClick={() => setOpen(false)}
                className="text-white"
                aria-label="Close menu"
              >
                <X size={28} />
              </button>
            </div>
            <nav className="flex flex-1 flex-col justify-center gap-2 px-8" aria-label="Mobile">
              {LINKS.map((link, i) => (
                <motion.button
                  key={link.id}
                  data-testid={`mobile-nav-link-${link.id}`}
                  onClick={() => go(link.id)}
                  className="text-left font-display text-6xl font-semibold uppercase leading-[1.05] text-white/90"
                  initial={{ y: 40, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.08 + i * 0.07, duration: 0.5, ease: [0.33, 1, 0.68, 1] }}
                >
                  <span className="mr-3 text-xl text-ember">0{i + 1}</span>
                  {link.label}
                </motion.button>
              ))}
            </nav>
            <p className="px-8 pb-10 font-body text-xs uppercase tracking-[0.3em] text-ash">
              Tools Built From Real Jobsite Problems
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
